import { defineStore } from 'pinia'
import { type VToastItem, type VToastOptions, VToastTypes } from './types'
import { useHelpers } from '@/shared/lib'
import { ref } from 'vue'

export const useToast = defineStore('toast', () => {
  const list = ref<VToastItem[]>([])
  const audio = ref<HTMLAudioElement | null>(null)
  const isAudio = ref(false)

  const { generateKey } = useHelpers()

  /**
   * Добавить аудио элемент
   * @param element
   */
  const addAudio = (element: HTMLAudioElement) => {
    audio.value = element
  }

  /**
   * Воспроизвести аудиофайл уведомления
   */
  const playAudio = () => {
    if (audio.value) {
      audio.value.currentTime = 0
      audio.value.play()
    }
  }

  /**
   * Общая функция добавления оповещений
   * @param option
   */
  const add = (option: VToastOptions) => {
    const { content, title = '', type = VToastTypes.SUCCESS, lifeTime = 0, link = '' } = option

    list.value.push({
      id: generateKey(),
      content,
      title,
      type,
      lifeTime,
      link,
    })
  }

  /**
   * Функция удаления оповещения
   * @param id
   */
  const remove = (id: string) => {
    list.value = list.value.filter((item) => item.id !== id)
  }

  /**
   * Функция удаления всех элементов списка
   */
  const clear = () => {
    list.value = []
  }

  return {
    list,

    add,
    remove,
    addAudio,
    isAudio,
    playAudio,
    clear,
  }
})
